import isString from 'lodash/isString';
import { tceFormatterInstance } from './TceFormatter';

export const MultipleTceFormatter = ({ value }) => {
    if (!value || value.length === 0) {
        return '';
    }

    if (isString(value)) {
        //formatted already
        return value;
    }

    const text: string[] = [];

    if (!Array.isArray(value)) {
        text.push(tceFormatterInstance.format(value));
    } else {
        value.forEach((part) => {
            text.push(tceFormatterInstance.format(part));
        });
    }

    return text.join(' ');
};
